import Vue from 'vue';
import VueRouter from 'vue-router';
import VueAnalytics from 'vue-analytics';
import VueAppInsights from 'vue-application-insights';
import { i18n } from '@/setup/i18n';
import routes from 'routes';
import store from 'store';
import NProgressApp from 'utils/nprogress';
import { UI_SET_LOADER } from 'store/actions/ui';

Vue.use(VueRouter);

const router = new VueRouter({
  mode: 'history',
  linkActiveClass: 'active',
  hashbang: false,
  root: '/',
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    return { x: 0, y: 0 };
  },
  routes
});

// Trackings
const googleAnalyticsId = process.env.GOOGLE_ANALYTICS_ID;
const appInsightsinStrKey = process.env.APP_INSIGHTS_INSTR_KEY;

if (process.env.NODE_ENV === 'production') {
  if (googleAnalyticsId) Vue.use(VueAnalytics, { id: googleAnalyticsId, router });
  if (appInsightsinStrKey) Vue.use(VueAppInsights, { id: appInsightsinStrKey, router });
}

router.beforeEach((to, from, next) => {
  const titleKey = to.meta.titleKey;
  const titleByKey = titleKey ? `| ${i18n.t(`title.${to.meta.titleKey}`)}` : '';
  document.title = `${process.env.APP_NAME} ${titleByKey}`;
  next();
});

// After navigation is confirmed, but before resolving...
router.beforeResolve((to, from, next) => {
  // If this isn't an initial page load.
  if (from.name) {
    // Start the route progress bar.
    NProgressApp.start();
  }
  next();
});

// When each route is finished evaluating...
// eslint-disable-next-line no-unused-vars
router.afterEach(to => {
  // Loader hidden
  store.dispatch(`ui/${UI_SET_LOADER}`, false);
  // Complete the animation of the route progress bar.
  NProgressApp.done();
});

export { router as default };
